import React, {useEffect, useState, useContext} from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter, Spinner,Table} from 'reactstrap';

const Generales = ({setItem,item}) => {
	const [ errors, setErrors ] = useState([]);
	const [ types, setTypes ] = useState([]);
	
	const [ loading, setLoading ] = useState(false);

    return (
		<div>
			<Table>
				<tbody>
					<tr>
						<th colSpan="2" style={{textAlign: 'center', background:'black', color:'white'}}>DATOS DEL CONCESIONARIO</th>
					</tr>
					<tr>
						<td><b>Nombre o Empresa:</b> <br/> {item.empresa}</td>
						<td><b>No ruta:</b> <br/> {item.no_ruta}</td>
					</tr>

					<tr>
						<th colSpan="2" style={{textAlign: 'center', background:'black', color:'white'}}>DATOS DEL VEHICULO</th>
					</tr>
					<tr>
						<td><b>Marca:</b> <br/>{item.marca ? item.marca:'X'}</td>
						<td><b>Modelo:</b> <br/>{item.modelo ? item.modelo:'X'}</td>
					</tr>					

					<tr>
						<td><b>Unidad:</b> <br/>{item.unidad}</td>
						<td><b>Concesion:</b> <br/>{item.concesion}</td>
					</tr>

					<tr>
						<td><b># Motor:</b> <br/> {item.no_motor}</td>
						<td><b>Serie Vehicular:</b> <br/> {item.placas}</td>
					</tr>
					<tr>
						<td><b>Año:</b> <br/> {item.anio?item.anio:0}</td>
					</tr>
					<tr>
						<td colSpan="2" style={{textAlign: 'center', background:'black', color:'white'}}>DATOS DE LA INSTALACIÓN</td>
					</tr>
					<tr>
						<td><b>Equipo:</b> <br/>{item?.equipo?.name}</td>
						<td><b>Ubicación GPS:</b> <br/>{item.ubicacion_gps}</td>
					</tr>

					<tr>
						<td><b>Domicilio:</b> <br/> {item.domicilio ? item.domicilio:'X'}</td>
						<td><b>Colonia:</b> <br/> {item.colonia ? item.colonia:'X'}</td>
					</tr>
					<tr>
						<td><b>Estado:</b> <br/> {item.estado ? item.estado.name:'X'}</td>
						<td><b>Municipio:</b> <br/> {item.municipio ? item.municipio:'X'}</td>
					</tr>
					<tr>
						<td><b>Celular:</b> <br/> {item.celular ? item.celular:'X'}</td>
						<td><b>IMEI:</b> <br/> {item.imei ? item.imei:'X'}</td>
					</tr>
					<tr>
						<td><b># Chip:</b> <br/> {item.chip ? item.chip:'X'}</td>
						<td><b>Tipo de Bloqueo:</b> <br/> {item.tipo_bloqueo ? item.tipo_bloqueo:'X'}</td>
					</tr>
					<tr>
						<td><b>Edo:</b> <br/> {item.edo ? item.edo:'X'}</td>
						<td><b>Instaladores:</b> <br/> {item.technicals_names}</td>
					</tr>
				</tbody>
			</Table>
			
		</div>
	);
}

export default Generales;